// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__3RXTl","title":"NotFound_title__19Trc","subtitle":"NotFound_subtitle__2WS7V","text":"NotFound_text__dFobo"};